import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import "./user.less";
import { mapActions } from "vuex";
import { getToken } from "@/libs/util";
import certificationCom from "@/view/user/certification";
import _resetPass from "./resetPass";
import center from "./center";
import _timeZone from "./timeZone";
import { updatepwd } from "@/api/pests";
import { add_table_data, edit_platform } from "@/api/chuku";
import { set_timezone } from "@/api/jingxiaoshang";
import { get_website_data } from "@/api/chuku";
import config from '@/config/index';
export default {
  name: "User",
  props: {
    // userAvator: {
    //   type: String,
    //   default: "",
    // },
    messageUnreadCount: {
      type: Number,
      default: 0
    },
    userName: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      formItem: {
        zhName: "",
        enName: "",
        image: null,
        select: "",
        img_url: null
      },
      insideSrc: null
    };
  },
  computed: {
    img_url: function img_url() {
      var cachedUrl = localStorage.getItem('logo_url');
      var baseUrl = process.env.NODE_ENV === "development" ? config.baseUrl.dev : process.env.VUE_APP_BUILD === "production" ? config.baseUrl.pro : config.baseUrl.alp;
      return "".concat(baseUrl).concat(cachedUrl || '');
    }
  },
  methods: _objectSpread({}, mapActions(["handleLogOut"]), {
    logout: function logout() {
      var _this2 = this;

      // debugger
      this.handleLogOut({
        token: getToken()
      }).then(function (res) {
        // debugger
        _this2.$router.push({
          name: "login"
        });
      });
    },
    message: function message() {
      this.$router.push({
        name: "message_page"
      });
    },
    ownSpace: function ownSpace() {
      this.$router.push({
        name: "ownspace"
      });
    },

    /**
     * 重置密码
     */
    resetPass: function resetPass() {
      var _this3 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this3.$t('重置密码')), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(_resetPass, {
            ref: "resetPass",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.resetPass;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formMoblie;
              updatepwd(formModel).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 时区设置
     */
    timeZone: function timeZone() {
      var _this4 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this4.$t('时区设置')), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(_timeZone, {
            ref: "timeZone",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.timeZone;
          obj.checkForm().then(function (res) {
            if (res) {
              //debugger
              //提交请求
              var formModel = obj.formMoblie;
              console.log("111", formModel);
              set_timezone(formModel).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg2 = res.errorMsg;
                  vm.$Message.success(_msg2);
                  vm.$Modal.remove();
                  vm.$store.state.user.userInfo.timezone = formModel.timezone;
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //实名认证
    certification: function certification() {
      var vm = this;
      var config = {
        loading: true,
        width: 800,
        okText: "确定",
        cancelText: "取消",
        render: function render(h) {
          return h("div", [h("h3", "实名认证"), h(certificationCom, {
            ref: "certificationCom",
            props: {
              edit: true,
              _vm: vm,
              $store: vm.$store
            }
          })]);
        },
        onOk: function onOk() {
          var _this5 = this;

          var _this = this;

          var obj = this.$refs.certificationCom;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              vm.$store.dispatch("handlereal_name_auth", formModel).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(_this5.$t('实名认证提交成功'));
                  vm.$Modal.remove(); //vm.init();
                } else {
                  vm.$Message.error(vm.errorCode[res.result]);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    helpSpace: function helpSpace() {
      //打开帮助中心
      window.open("http://" + window.location.host + "/help");
    },
    personalCenter: function personalCenter() {
      var _this6 = this;

      console.log("点击了个人中心"); // this.modal1 = true;

      var vm = this;
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this6.$t('个人中心')), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(center, {
            ref: "center",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.center;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              console.log('obj.formModel', obj.formModel);
              var data = {
                web_name: [{
                  "zh": obj.formModel.filename,
                  "en": obj.formModel.merchant_name
                }],
                logo_url: obj.formModel.fileinfo
              };
              edit_platform(data).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  localStorage.setItem("shuaxin", obj.formModel.desc);
                  var _msg3 = res.errorMsg;
                  vm.$Message.success(_msg3);
                  vm.$Modal.remove();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    beforeUpload: function beforeUpload(file) {
      var _this7 = this;

      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function (event) {
        _this7.insideSrc = event.srcElement.result;
      };

      return false;
    },
    handleClick: function handleClick(name) {
      // debugger
      switch (name) {
        case "logout":
          // debugger
          this.logout();
          break;

        case "resetPass":
          this.resetPass();
          break;

        case "timeZone":
          this.timeZone();
          break;

        case "ownSpace":
          this.ownSpace();
          break;

        case "certification":
          this.certification();
          break;

        case "feedbackList":
          this.feedbackList();
          break;

        case "center":
          this.personalCenter();
          break;
      }
    }
  }),
  mounted: function mounted() {//   get_website_data().then((res) => {
    //   console.log("登录信息111", res.body.logo_url);
    //   this.img_url= `${
    //       process.env.NODE_ENV === "development"
    //         ? config.baseUrl.dev
    //         : process.env.VUE_APP_BUILD === "production"
    //         ? config.baseUrl.pro
    //         : config.baseUrl.alp
    //     }${res.body.logo_url}`
    //     console.log("登录信息111", this.img_url);
    // });
  }
};